import { Container, Col, Row } from 'react-bootstrap';
import logo from '../assets/images/klett_logo.jpg';

const FooterComponent = () => {

  return(
    <footer>
     <Container className="py-lg-3 py-2 text-lg-start text-center">
          
          <Row>
            <Col className="col-xl-3 col-lg-4 col-6">
              <a href="https://klett.pl" target="_blank" rel="noopener noreferrer">
                <img src={logo} alt="Klett Polska sp. z o.o." />
              </a>
            </Col>
            <Col className="d-none d-lg-block text-end pt-2 col-xl-9 col-lg-8">
              <a href="https://klett.pl/polityka-cookies" target="_blank" rel="noopener noreferrer">Polityka Cookies</a>
              <a href="https://klett.pl/regulamin-ksiegarni" target="_blank" rel="noopener noreferrer">Regulamin</a>
              <a href="https://klett.pl/polityka-prywatnosci" target="_blank" rel="noopener noreferrer">Polityka prywatności</a>
              <a href="https://klett.pl/kontakt" target="_blank" rel="noopener noreferrer">Kontakt</a>
            </Col>
          </Row>

        </Container>
    </footer>
  )

}
export default FooterComponent;